import React, { forwardRef } from 'react'
import PerfectScrollbar from 'react-perfect-scrollbar'
import { Box } from '@mui/material'

interface ScrollbarProps {
	children?: React.ReactNode
	style?: Record<string, any>
	options?: {
		suppressScrollX?: boolean
		suppressScrollY?: boolean
	}
}

const Scrollbar = forwardRef<any, ScrollbarProps>((props, ref) => {
	const { children, ...other } = props

	const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
		navigator.userAgent
	)

	if (isMobile) {
		return (
			<Box ref={ref} sx={{ overflowX: 'auto' }}>
				{children}
			</Box>
		)
	}

	return (
		<PerfectScrollbar ref={ref} {...other}>
			{children}
		</PerfectScrollbar>
	)
})

export default Scrollbar
